(function () {
  'use strict';

  function init(carousel) {
    if (carousel.dataset.featuredCarouselInit) return;
    carousel.dataset.featuredCarouselInit = 'true';

    const track = carousel.querySelector('[data-featured-track]');
    const prev = carousel.querySelector('[data-featured-prev]');
    const next = carousel.querySelector('[data-featured-next]');
    const section = carousel.closest('section');
    const expandBtn = section ? section.querySelector('[data-featured-expand]') : null;
    const expandLabel = expandBtn ? expandBtn.querySelector('[data-featured-expand-label]') : null;
    if (!track) return;

    // Scorre di una "pagina" intera (quante card sono visibili in quel momento)
    function page() {
      const card = track.querySelector('.product-card');
      if (!card) return track.clientWidth;
      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const step = card.getBoundingClientRect().width + gap;
      const perView = Math.max(1, Math.round(track.clientWidth / step));
      return step * perView;
    }

    function syncNav() {
      if (carousel.classList.contains('is-expanded')) {
        if (prev) prev.hidden = true;
        if (next) next.hidden = true;
        return;
      }
      const max = track.scrollWidth - track.clientWidth - 2;
      const scrollable = max > 0;
      if (prev) {
        prev.hidden = !scrollable;
        prev.disabled = track.scrollLeft <= 2;
      }
      if (next) {
        next.hidden = !scrollable;
        next.disabled = track.scrollLeft >= max;
      }
    }

    if (prev) prev.addEventListener('click', () => track.scrollBy({ left: -page(), behavior: 'smooth' }));
    if (next) next.addEventListener('click', () => track.scrollBy({ left: page(), behavior: 'smooth' }));
    track.addEventListener('scroll', syncNav, { passive: true });
    window.addEventListener('resize', syncNav);

    if (expandBtn) {
      expandBtn.addEventListener('click', () => {
        const expanded = carousel.classList.toggle('is-expanded');
        expandBtn.setAttribute('aria-expanded', String(expanded));
        if (expandLabel) expandLabel.textContent = expanded ? 'Mostra meno' : 'Vedi tutti';
        if (!expanded) track.scrollLeft = 0;
        syncNav();
      });
    }

    syncNav();
  }

  document.querySelectorAll('[data-featured-carousel]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-featured-carousel]').forEach(init));
})();
